import React, { useEffect } from 'react';
import {
  Form,
  FormInstance,
  SelectBooleanInput,
  NumberInput
} from '@lightbeamhealth/blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxEndodbSettingsData {
  alerts: boolean;
  usePostprandialThresholds: boolean;
  thresholds: {
    red: {
      fasting: {
        avg: number;
        max: number;
        min: number;
      };
      postprandial: {
        max: number;
        min: number;
      };
    };
    yellow: {
      fasting: {
        avg: number;
      };
    };
  };
}

const DefaultSettings: EpxEndodbSettingsData = {
  alerts: true,
  usePostprandialThresholds: false,
  thresholds: {
    red: {
      fasting: {
        avg: 200,
        max: 400,
        min: 70
      },
      postprandial: {
        max: 200,
        min: 65
      }
    },
    yellow: {
      fasting: {
        avg: 130
      }
    }
  }
};

interface EpxEndodbSettingsProps {
  setForm?: (form: FormInstance<EpxEndodbSettingsData>) => void;
  onSubmit?: (data: EpxEndodbSettingsData) => void;
  disabled?: boolean;
}

const EpxEndodbSettings = ({
  setForm,
  onSubmit,
  disabled
}: EpxEndodbSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxEndodbSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  return (
    <CardBlock bare>
      <Form form={form} onSubmit={onSubmit}>
        {(props) => (
          <CardBlock>
            <Row>
              <Col sm={12}>
                <SelectBooleanInput
                  label="Enable Alerts for Patient"
                  name="alerts"
                  fill
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <NumberInput
                  label="Alert - Fasting Max"
                  name="thresholds.red.fasting.max"
                  required
                  fill
                  disabled={disabled}
                />
              </Col>
              <Col sm={12}>
                <NumberInput
                  label="Alert - Fasting Min"
                  name="thresholds.red.fasting.min"
                  required
                  fill
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <SelectBooleanInput
                  label="Use Thresholds for Postprandial"
                  name="usePostprandialThresholds"
                  fill
                  disabled={disabled}
                />
              </Col>
            </Row>
            {props.values.usePostprandialThresholds && (
              <Row>
                <Col sm={12}>
                  <NumberInput
                    label="Alert - Postprandial Max"
                    name="thresholds.red.postprandial.max"
                    required
                    fill
                    disabled={disabled}
                  />
                </Col>
                <Col sm={12}>
                  <NumberInput
                    label="Alert - Postprandial Min"
                    name="thresholds.red.postprandial.min"
                    required
                    fill
                    disabled={disabled}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col sm={12}>
                <NumberInput
                  label="Red - Fasting Avg"
                  name="thresholds.red.fasting.avg"
                  required
                  fill
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <NumberInput
                  label="Yellow - Fasting Avg"
                  name="thresholds.yellow.fasting.avg"
                  required
                  fill
                  disabled={disabled}
                />
              </Col>
            </Row>
          </CardBlock>
        )}
      </Form>
    </CardBlock>
  );
};

export default EpxEndodbSettings;
